export const config = {
    API_URL: process.env.REACT_APP_API_URL || "http://localhost:8080",
    AWS: {
        S3_BASE_URL: process.env.REACT_APP_S3_BASE_URL,
    },
};
